
<template>
    <div class="filter-top">

        <div class="filter-drop border-bottom">

            <div @click.stop="handler(1)"
                 class="name1"
                 v-if="this.$slots.name1">
                <span><slot name="name1"></slot>
                    <i class="triangle triangle-down"></i>
                </span>
            </div>

            <div @click.stop="handler(2)"
                 class="name2"
                 v-if="this.$slots.name2">
                <span><slot name="name2"></slot> <i class="triangle triangle-down"></i></span>
            </div>

            <div v-if="this.$slots.name3"
                 class="name3"
                 @click.stop="handler(3)">
                <span><slot name="name3"></slot>  <i class="triangle triangle-down"></i></span>
            </div>

            <div v-if="this.$slots.tips" class="flex1">
                <slot name="tips"></slot>
            </div>
        </div>

        <Popup v-model="show" type="top">
            <slot></slot>
        </Popup>

    </div>

</template>
<script>

    import Popup from "../popup/Popup";
    import {ClearBodyOverHidden, SetBodyOverHidden} from "../../../assets/js/utils";

    export default {
        props: {
            popup: {
                type: Function,
                default: () => {
                }
            }
        },

        data() {
            return {
                type: 1,
                show: false
            }
        },
        watch: {
            show(newVal){
                this.$emit('showchange', newVal);
            }
        },
        components: {
            Popup
        },
        methods: {
            hide() {
                this.show = false;
                // ClearBodyOverHidden();
            },
            open() {
                this.show = true;
                // SetBodyOverHidden();
            },
            handler(type) {
                let show = this.show;

                if (type === this.type) {
                    show = !show;
                } else {
                    show = true
                }


                if (this.popup({type, display: show}) === false) {
                    return
                }
                this.type = type;
                if(type){
                    this.open()
                }else {
                    this.hide()
                }
            }
        }

    }
</script>